import Service from "../Service";
const resource = "/TransportPriceRate/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID },
    });
  },
  getPricesByLocality(parameters, requestID) {
    return Service.post(resource + "getPricesByLocality", parameters, {
      params: { requestID },
    });
  },
};
